var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('File1'),_c('File2'),_c('File3'),_c('File4'),_c('File5'),_c('File6')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }